import { BookOpen, CalendarDays, Compass, DoorOpen, GraduationCap, Globe2, Home, ListChecks, type LucideIcon } from 'lucide-react';
import type { MessageKey } from '@/lib/i18n';

export interface PublicNavItem {
  id: string;
  labelKey: MessageKey;
  to: string;
  icon: LucideIcon;
  end?: boolean;
}

/** OPAC top navigation. */
export const PUBLIC_NAV: readonly PublicNavItem[] = [
  { id: 'home', labelKey: 'nav.home', to: '/', icon: Home, end: true },
  { id: 'search', labelKey: 'nav.search', to: '/search', icon: BookOpen },
  { id: 'browse', labelKey: 'nav.browse', to: '/browse', icon: Compass },
  { id: 'lists', labelKey: 'nav.lists', to: '/lists', icon: ListChecks },
  { id: 'events', labelKey: 'nav.events', to: '/events', icon: CalendarDays },
  { id: 'rooms', labelKey: 'nav.rooms', to: '/rooms', icon: DoorOpen },
  { id: 'courses', labelKey: 'nav.courses', to: '/courses', icon: GraduationCap },
  { id: 'resources', labelKey: 'nav.resources', to: '/resources', icon: Globe2 },
];

export interface AccountNavItem {
  id: string;
  labelKey: MessageKey;
  to: string;
  end?: boolean;
}

/** Patron account sub-navigation (/account/...). */
export const ACCOUNT_NAV: readonly AccountNavItem[] = [
  { id: 'overview', labelKey: 'nav.account', to: '/account', end: true },
  { id: 'loans', labelKey: 'account.loans', to: '/account/loans' },
  { id: 'holds', labelKey: 'account.holds', to: '/account/holds' },
  { id: 'fines', labelKey: 'account.fines', to: '/account/fines' },
  { id: 'history', labelKey: 'account.history', to: '/account/history' },
  { id: 'lists', labelKey: 'account.lists', to: '/account/lists' },
  { id: 'suggestions', labelKey: 'account.suggestions', to: '/account/suggestions' },
  { id: 'ill', labelKey: 'account.ill', to: '/account/ill' },
  { id: 'events', labelKey: 'account.events', to: '/account/events' },
  { id: 'notifications', labelKey: 'account.notifications', to: '/account/notifications' },
  { id: 'profile', labelKey: 'account.profile', to: '/account/profile' },
  { id: 'preferences', labelKey: 'account.preferences', to: '/account/preferences' },
];
